export default {
  data() {
    return {
      isAdyenLoading: true,
      sessionData: null,
    };
  },
  computed: {
    environment() {
      let result = "test";
      if (process.env.NODE_ENV === "production") {
        result = "live";
      }
      return result;
    },
    getLocale() {
      let locale = this.$store.getters.getLocale;
      switch (locale) {
        case "de":
          locale += "_DE";
          break;
        case "en":
          locale += "_US";
          break;
      }
      return locale;
    },
    shopChosenPackage() {
      return this.$store.getters["shop/getShopChosenPackage"];
    },
    sessionConfig() {
      return {
        locale: this.getLocale,
        offerId: this.shopChosenPackage.id,
        returnUrl: process.env.VUE_APP_HOST + this.$route.fullPath,
      };
    },
  },
  methods: {
    initializeAdyenConfig(payload, sessionId) {
      return {
        session: { id: sessionId, sessionData: payload.sessionData },
        environment: this.environment,
        amount: payload.amount.value,
        countryCode: payload.countryCode,
        locale: this.getLocale,
        clientKey: process.env.VUE_APP_PAYMENT_ADYEN_CLIENT_KEY,
        onPaymentCompleted: (result) => {
          console.info(result);
          this.$store.commit("shop/setPaymentMethod", "adyen");
          this.$store.commit("shop/setPaymentStatus", result.resultCode);
          this.$emit("payment-done");
          this.$bvModal.hide("modal-payment");
          this.sendPaymentAnalytics();
        },
        onPaymentFailed: (result, component) => {
          console.info(result, component);
          this.$store.commit("shop/setPaymentStatus", result.resultCode);
          this.$store.commit("shop/setPaymentError", true);
        },
        onError: (error, component) => {
          this.$store.commit("shop/setPaymentError", true);
          this.$store.commit("shop/setPaymentStatus", error.name);
          console.error(error.name, error.message, error.stack, component);
        },
      };
    },
  },
};
